export const levelTestTheme = {
    primary: "#2557d6",
    accent: "#f2b705",
    background: "#f5f7fb",
    card: "#ffffff",
    text: "#162136",
    mutedText: "#667085",
    buttonText: "#ffffff",
    progress: "#2557d6",
    border: "#d8deea",
    radius: "14px",
    fontFamily: "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    headlineScale: 1,
    bodyScale: 1,
    spacingDensity: "comfortable"
};
